<template>
  <div class="flex flex-col">
    <span class="text-sm border-b text-gray-400">Route Pulling</span>
    <div class="flex flex-col bg-gray-50 p-2 rounded-md shadow-md">
      <div class="flex flex-col">
        <div class="flex p-2"
          v-if="errorMessage">
          Error: {{ errorMessage }}
        </div>
        <div class="flex flex-row">
          <div class="flex flex-col p-2 w-2/3">
            <div class="mt-2 text-lg font-italic border-b border-gray-600">
              Partitions:
            </div>
            <div class="grid grid-cols-3 gap-1">
              <div class="flex flex-row"
                v-for="(partition, index) in partitions"
                :key="partition.id">
                <label class="flex flex-row p-1 w-full bg-sky-200 rounded-md">
                  <button class="w-6 h-6 rounded-md"
                    :class="{
                      'bg-gray-400': !selectedPartitions[index],
                      'bg-sky-600': selectedPartitions[index],
                      'hover:bg-gray-200': !selectedPartitions[index],
                      'hover:bg-sky-100': selectedPartitions[index],
                    }"
                    @click="toggleSelectedPartition(index)"
                  ></button>
                  <div class="pl-2">
                    <span class="border-b border-gray-600">{{ partition.description }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-2 p-2 w-1/3">
            <div class="mt-2 text-lg font-italic border-b border-gray-600">
              Configuration:
            </div>
            <CalendarField class="mx-2"
              v-model="routePullingDate">
              Date
            </CalendarField>
            <div class="flex flex-col">
              <span class="px-2 py-1">Options</span>
              <label class="px-2">
                <input class="mx-2"
                  type="checkbox"
                  v-model="prerunVehicleSync"
                />
                Pre-Run Vehicle Sync
              </label>
              <label class="px-2">
                <input class="mx-2"
                  type="checkbox"
                  v-model="prerunBuildingSync"
                />
                Pre-Run Building Sync
              </label>
              <label class="px-2">
                <input class="mx-2"
                  type="checkbox"
                  v-model="skipStudentValidateStep"
                />
                Skip Student Validate Step
              </label>
              <label class="px-2">
                <input class="mx-2"
                  type="checkbox"
                  v-model="triggerNotifications"
                />
                Trigger Notifications
              </label>
            </div>
            <div class="flex flex-row items-center justify-center">
              <Button class="mx-2 flex-grow"
                color="blue"
                size="md"
                @click="startRoutePull">
                Route Pull
              </Button>
              <label class="py-2 mt-2 text-gray-400 font-italic"
                v-if="showForceNew">
                <input
                  type="checkbox"
                  v-model="forceNew"
                />
                Force New
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- <RoutePullTaskContent
        v-if="routePullId"
        :routePullData="routePullData"
      /> -->
      <RoutePullList
        ref="routePullList"
      />
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'

import Button from '../../Button.vue'
import CalendarField from '../../formComponents/CalendarField.vue'

import RoutePullList from './RoutePullList.vue'

import time from '../../../services/utils/time.js'
import user from '../../../services/user/user.js'
import partitions from '../../../services/partitions.js'

import routePullService from '../../../services/activeSync/routePull.js'

export default {
  components: {
    Button,
    CalendarField,
    RoutePullList,
  },
  data() {
    return {
      user: undefined,

      prerunVehicleSync: false,
      prerunBuildingSync: false,
      skipStudentValidateStep: false,
      triggerNotifications: false,
      forceNew: false,
      routePullingDate: undefined,

      errorMessage: undefined,

      showForceNew: false,

      routePullId: undefined,
      routePullData: undefined,

      partitions: [],
      selectedPartitions: [],
    }
  },
  methods: {
    async startRoutePull() {
      try {
        this.errorMessage = undefined
        let selectedPartitionIds = this.getSelectedPartitionIds()
        let options = this.createOptions()

        this.routePullId = await routePullService.getOrInitRoutePull(selectedPartitionIds, this.routePullingDate, options, this.forceNew)
        this.$refs['routePullList'].getRoutePullList()
        // routePullService.initDataPolling(this.routePullId, this.setRoutePullData)
      }
      catch (error) {
        this.errorMessage = error
        this.routePullId = undefined
      }
    },
    setRoutePullData(data) {
      this.routePullData = data
    },
    toggleSelectedPartition(index) {
      this.$set(this.selectedPartitions, index, !this.selectedPartitions[index])
    },
    getSelectedPartitionIds() {
      return this.selectedPartitions.reduce((aggregate, curr, index) => {
        if (curr) {
          aggregate.push(this.partitions[index].id)
        }
        return aggregate
      }, [])
    },
    createOptions() {
      let options = {}
      if (this.prerunVehicleSync) {
        options['prerun_vehicle_sync'] = true
      }
      if (this.prerunBuildingSync) {
        options['prerun_building_sync'] = true
      }
      if (this.skipStudentValidateStep) {
        options['skip_student_validate_step'] = true
      }
      if (this.triggerNotifications) {
        options['trigger_notifications'] = true
      }
      return options
    },
  },
  async mounted() {
    this.routePullingDate = time.today()
    this.user = await user.get()
    if (this.user.can('force_start_route_pull_entry')) {
      this.showForceNew = true
    }
    await partitions.getPartitionFromServer()
    this.partitions = await partitions.getPartition()
    this.partitions = sortBy(this.partitions, ['description'])
    this.$set(this, 'selectedPartitions', this.partitions.map(() => false))
  },
}
</script>
